<!-- Staff "alias" (read-only impersonation) session banner — Task 16. Mounted
     once, above every layout branch below, so it stays visible across the
     whole vendor portal regardless of route. Self-hides via *ngIf on
     AliasSessionService.isAliased() inside the component's own template, so
     it renders nothing (no host markup) for the vast majority of sessions
     that are never aliased. -->
<app-alias-banner></app-alias-banner>

<!-- Root layout branch:
     1. Bare routes   -> bare <router-outlet>, no shell. The auth screens, plus
                         the site contact's no-login site-visit page.
                         🔴 Checked FIRST, ahead of the INTERNAL branch below,
                         which keys on the stored profile rather than the route:
                         a signed-in staffer opening a site contact's link must
                         get the external page, not the internal chrome wrapped
                         around it. See AppComponent.isPublicSiteVisitRoute.
     2. Internal      -> dedicated <app-internal-header> + full-bleed main.
                         Fires for internal-prefixed routes OR an INTERNAL user,
                         so shared/unguarded routes (e.g. /settings) still keep
                         INTERNAL users off the vendor shell.
     3. Vendor (PA)   -> CONNECT 2.0 <app-vendor-shell> (rail + top strip).
     The branches are mutually exclusive, so only one <router-outlet> is ever
     instantiated at a time. -->
<ng-container *ngIf="isBareRoute; else appShell">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #appShell>
  <ng-container *ngIf="isInternalRoute || isInternalUser; else vendorShell">
    <main class="main main--internal">
      <app-internal-header></app-internal-header>
      <div class="content content--full">
        <router-outlet></router-outlet>
      </div>
    </main>
  </ng-container>

  <ng-template #vendorShell>
    <app-vendor-shell></app-vendor-shell>
  </ng-template>
</ng-template>

<!-- Step-up re-auth modal host. Mounted OUTSIDE the auth/internal/vendor route
     branches above (a step-up can be triggered by a sensitive request on any
     authenticated route) so exactly one modal host exists app-wide. Renders
     nothing until the interceptor opens it via StepUpService. -->
<app-step-up-reauth></app-step-up-reauth>
